import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import logo from './logo.svg';
import './index.css';
import UserDetails from "../src/components/dashboard/admin/userDetails"
import Login from "./components/login";
import Admin from './components/dashboard/admin';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import Header from './components/header';
import BranchManager from "./components/dashboard/branchManager/index"
import BranchManagerReschedule from "./components/dashboard/branchManager/reschedule"
import store from "./reduxStore/store";
import { Provider } from "react-redux";
import HolidaysList from './components/dashboard/holidaysList/index.js';

function AppContent() {
  const location = useLocation();
  const hideHeaderOnRoutes = ['/', '/configure', '/configure/login'];
  const shouldShowHeader = !hideHeaderOnRoutes.includes(location.pathname);

  return (
    <>
    <Header shouldShowHeader={shouldShowHeader} />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/configure" element={<Login />} />
           <Route path="/configure/login" element={<Login />} />
        <Route path="/configure/dashboard" element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        } />
        <Route path="/configure/login" element={<Login />} />
        <Route path="/configure/user-details" element={
          <ProtectedRoute>
            <UserDetails />
          </ProtectedRoute>
        } />
        <Route path="/configure/holidays" element={
          <ProtectedRoute>
            <HolidaysList />
          </ProtectedRoute>
        } />
        <Route path="/configure/branch-manager" element={
          <ProtectedRoute>
            <BranchManager />
          </ProtectedRoute>
        } />
        <Route path="/configure/branch-manager/reschedule/:postCode/:recordId" element={
          <ProtectedRoute>
            <BranchManagerReschedule />
          </ProtectedRoute>
        } />
        
        {/* optional: 404 */}
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
